import { useEffect } from 'react';

export const useApiCall = (callback: () => Promise<void>) => {
  useEffect(() => {
    let ignore = false;
    (async () => {
      await Promise.resolve();
      if (ignore) {
        return;
      }
      await callback();
    })();
    return () => {
      ignore = true;
    };
  }, [callback]);
};
